import React from 'react';

export const AdvancedSearch = React.lazy(() =>
  import('./AdvancedSearch/AdvancedSearch').then((m) => ({ default: m.AdvancedSearch })),
);

export const SearchResults = React.lazy(() => import('./SearchResults/SearchResults'));
